import { HYDRATE } from "next-redux-wrapper";
import { ActionsCartTotal } from "./actions";

const initialState = { data: {}, status: "fetch_init", message: "" };

function storeCartTotals(state = initialState, action) {

	switch (action.type) {

	case HYDRATE: {

		return { ...state, ...action.payload.storeCartTotals };

	}
	case ActionsCartTotal.LOAD_GET_CART_TOTAL:
		return { ...state, data: action.data, status: "fetch_loading" };
	case ActionsCartTotal.RES_GET_CART_TOTAL:
		return { ...state, data: action.data, status: "fetch_result" };
	case ActionsCartTotal.ERR_GET_CART_TOTAL:
		return {
			...state, data: {}, status: "fetch_error", message: "Error...",
		};
	default: {

		return {
			...state,
		};

	}

	}

}

export default storeCartTotals;
